<template>
	<nuxt-link v-if="content?.slug?.current" class="featured row"
						 :key="contentTitle"
						 :to="localePath(`/news/${content.slug.current}`)"
						 @click="$toggleNav">
		<div class="col-md-7">
			<img v-if="content?.thumb?.asset?.url" :src="$urlFor(content.thumb.asset.url, 600)"
					 :alt="newsItemAlt"
					 class="featured__image"
					 loading="lazy"
					 :height="content.thumb.asset.metadata.dimensions.height"
					 :width="content.thumb.asset.metadata.dimensions.width"
					 sizes="sm:100vw md:50vw lg:600px" />
		</div>
		<div class="featured__details col-md-5">
			<h5 class="featured__content-type">{{ contentType }}</h5>
			<h3 class="featured__title">{{ contentTitle }}</h3>
		</div>
	</nuxt-link>
</template>


<script setup>
import { useI18n, useLocalePath } from '#imports'
const { locale } = useI18n()
const localePath = useLocalePath()
import {computed} from 'vue'
const props = defineProps({
  content: Object
})
const contentType = computed(() => locale.value === 'en' ? 'Latest News' : '最新ニュース')
const newsItemAlt = computed(() => locale.value === 'en' ? props.content?.thumbAlt?.en : props.content?.thumbAlt?.jp)
const contentTitle = computed(() => locale.value === 'en' ? props.content?.title?.en : props.content?.title?.jp)
</script>
